/* eslint-disable */
import { StyleSheet } from "react-native"
import { ApplicationStyles } from "../../Themes/"

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container : {
    flex : 1
  },
  cellbg1: {
    backgroundColor: "rgba(222, 238, 249, 255)"
  },
  cellbg2: {
    backgroundColor: "rgba(237, 244, 213, 255)"
  },
  cellbg3: {
    backgroundColor: "rgba(249, 216, 200, 255)"
  },
  cellbg4: {
    backgroundColor: "rgba(251, 236, 209, 255)"
  },
  containerGridLeft: {
    justifyContent: "space-around",
    alignItems: "center",
    flex: 1,
    backgroundColor: "#ffbb00"
  },
  containerGridMiddle: {
    justifyContent: "space-around",
    alignItems: "center",
    flex: 1,
    backgroundColor: "#00a1f1"
  },
  containerGridRight: {
    justifyContent: "space-around",
    alignItems: "center",
    flex: 1,
    backgroundColor: "#7cbb00"
  },
  smallIcon: {
    height: 10,
    position: 'absolute',
    bottom: 10,
    right: 10
  }

})
